import { setBooleanAttribute } from './dom.js';
import { DATA_PREVENT_HTML_SCROLL, DATA_HTML_SCROLLS } from '../styles/scroll.css.js';

// Incremented / decremented as elements request scroll lock/unlock.
let scrollLockCount = 0;
/**
 * Call to prevent the page from scrolling. Returns a function that can be called to re-enable
 * page scroll.
 *
 * Designed to be able to be called multiple times, but must be called the same number of times to
 * re-enable scrolling. Should be tied to a component's mount/unmount cycle.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   if (shouldDisable) {
 *     return disablePageScroll()
 *   }
 * }, [shouldDisable])
 * ```
 */
function disablePageScroll() {
    const html = document.documentElement;
    if (scrollLockCount++ === 0) {
        const hasVerticalScrollbar = window.innerWidth - html.clientWidth > 0;
        setBooleanAttribute(html, DATA_PREVENT_HTML_SCROLL, true);
        if (hasVerticalScrollbar)
            setBooleanAttribute(html, DATA_HTML_SCROLLS, true);
    }
    return () => {
        scrollLockCount = Math.max(0, scrollLockCount - 1);
        if (scrollLockCount === 0) {
            setBooleanAttribute(html, DATA_PREVENT_HTML_SCROLL, false);
            setBooleanAttribute(html, DATA_HTML_SCROLLS, false);
        }
    };
}

export { disablePageScroll };
//# sourceMappingURL=scroll.js.map
